//      
export { default } from './connected-droppable';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/droppable/index.js